import { USER_ROLES } from "@/mappings/user-roles";
import AffiliatePage from "@/views/affiliates/AffiliatePage.vue";
import CreateAffiliatePage from "@/views/affiliates/CreateAffiliatePage.vue";
import AffiliatesList from "@/views/affiliates/AffiliatesList.vue";
import BufferAccounts from "@/views/affiliates/BufferAccounts.vue";
import Newcomers from "@/views/affiliates/Newcomers.vue";
import RegistrationSingle from "@/views/affiliates/RegistrationSingle.vue";
import RegistrationsList from "@/views/affiliates/RegistrationsList.vue";
import ChangeMethodRequests from "@/views/affiliates/affiliateMethods/List.vue";
import ChangeMethodRequest from "@/views/affiliates/affiliateMethods/Single.vue";
import BillSingle from "@/views/affiliates/bills/BillSingle.vue";
import BillsList from "@/views/affiliates/bills/BillsList.vue";
import ChargeRequest from "@/views/affiliates/chargeRequest/ChargeRequest.vue";
import ChargeRequests from "@/views/affiliates/chargeRequest/ChargeRequests.vue";
import CreateChargeRequest from "@/views/affiliates/chargeRequest/CreateChargeRequest.vue";
import AffiliateInvoicePage from "@/views/affiliates/invoices/AffiliateInvoicePage.vue";
import AffiliateInvoices from "@/views/affiliates/invoices/AffiliateInvoices.vue";
import CreatePayment from "@/views/affiliates/payments/CreatePayment.vue";
import Payment from "@/views/affiliates/payments/Payment.vue";
import Payments from "@/views/affiliates/payments/Payments.vue";
import HoldList from "@/views/hold/HoldList.vue";
import HoldSingle from "@/views/hold/HoldSingle.vue";

export default [
    {
        path: 'registrations',
        name: 'registrations',
        component: RegistrationsList,
        meta: {
            title: 'Регистрации',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR,
            ],
        },
    },
    {
        path: 'registration/:id',
        name: 'registration',
        component: RegistrationSingle,
        meta: {
            title: 'Регистрация',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR,
            ],
        },
    },
    {
        path: 'all',
        name: 'affiliates-list',
        component: AffiliatesList,
        meta: {
            title: 'Список партнёров',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'affiliate/:id',
        name: 'affiliate',
        component: AffiliatePage,
        meta: {
            title: 'Детальная страница партнера',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'create-affiliate',
        name: 'create-affiliate',
        component: CreateAffiliatePage,
        meta: {
            title: 'Создание партнёра',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'buffer-accounts',
        name: 'buffer-accounts',
        meta: {
            title: 'Буферные аккаунты',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: BufferAccounts,
    },
    {
        path: 'newcomers',
        name: 'newcomers',
        component: Newcomers,
        meta: {
            title: 'Новореги',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'change-method-requests',
        name: 'change-method-requests',
        meta: {
            title: 'Запросы на изменение способа выплат',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: ChangeMethodRequests,
    },
    {
        path: 'change-method-request/:id',
        name: 'change-method-request',
        props: true,
        meta: {
            title: 'Запрос на изменение способа выплат',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: ChangeMethodRequest,
    },
    {
        path: 'bills',
        name: 'bills',
        meta: {
            title: 'Платежи',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: BillsList,
    },
    {
        path: 'bill/:id',
        name: 'bill',
        meta: {
            title: 'Платёж',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: BillSingle,
    },
    {
        path: 'payments',
        name: 'payments',
        meta: {
            title: 'Список досрочек',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: Payments,
    },
    {
        path: 'payment/:id',
        name: 'payment',
        meta: {
            title: 'Досрочка',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: Payment,
    },
    {
        path: 'create-payment',
        name: 'create-payment',
        meta: {
            title: 'Создание досрочки',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: CreatePayment,
    },
    {
        path: 'affiliate-invoices',
        name: 'affiliate-invoices',
        meta: {
            title: 'Партнёрские счета',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: AffiliateInvoices,
    },
    {
        path: 'affiliate-invoice/:id',
        name: 'affiliate-invoice',
        meta: {
            title: 'Партнерский счет',
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: AffiliateInvoicePage,
    },
    {
        path: 'charge-requests',
        name: 'charge-requests',
        meta: {
            title: 'Заявки на расход',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.SUPPORT, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
        component: ChargeRequests,
    },
    {
        path: 'charge-request/:id',
        name: 'charge-request',
        component: ChargeRequest,
        meta: {
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN,
                USER_ROLES.AFFILIATE_MANAGER,
                USER_ROLES.FINANCIER,
                USER_ROLES.SUPERVISOR,
                USER_ROLES.SUPPORT,
                USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'create-charge-request',
        name: 'create-charge-request',
        component: CreateChargeRequest,
        meta: {
            title: 'Создание заявки на расход',
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN,
                USER_ROLES.AFFILIATE_MANAGER,
                USER_ROLES.FINANCIER,
                USER_ROLES.SUPERVISOR,
                USER_ROLES.SUPPORT,
                USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'edit-charge-request/:id',
        name: 'edit-charge-request',
        component: CreateChargeRequest,
        meta: {
            title: 'Редактирование заявки на расход',
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN,
                USER_ROLES.AFFILIATE_MANAGER,
                USER_ROLES.FINANCIER,
                USER_ROLES.SUPERVISOR,
                USER_ROLES.SUPPORT,
                USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'hold',
        name: 'hold',
        component: HoldList,
        meta: {
            title: 'История холда',
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN,
            ],
        },
    },
    {
        path: 'hold-single',
        name: 'hold-single',
        component: HoldSingle,
        meta: {
            title: 'Холд',
            requiresAuth: true,
            roles: [
                USER_ROLES.ADMIN,
            ],
        },
    },
    {
        path: 'balance',
        name: 'balance-list',
        component: (): Promise<any> => import('@/views/balance/BalanceList.vue'),
        meta: {
            title: 'Баланс',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR],
        },
    },
    {
        path: 'balance/:id',
        name: 'balance',
        component: (): Promise<any> => import('@/views/balance/BalanceSingle.vue'),
        meta: {
            title: 'Баланс',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR],
        },
    },
    {
        path: 'create-balance',
        name: 'create-balance',
        component: (): Promise<any> => import('@/views/balance/CreateBalance.vue'),
        meta: {
            title: 'Корректировка баланса',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR],
        },
    },
];
